import * as React from "react";
const SvgTriangleUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 15, viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 9H11L7.5 4.5L4 9Z", fill: "currentColor" }));
export default SvgTriangleUp;
